import React from 'react';
import { DoNotSell } from './routes/doNotSell';
export const App = () => {
    return React.createElement(DoNotSell, null);
};
